// extracted by mini-css-extract-plugin
module.exports = {"LanguageSelector":"LanguageSelector_LanguageSelector__22Oym","active":"LanguageSelector_active__1MxbX"};